import { ProcesarDatosApi } from "../api/ApiFetch";
const controladorProyecto = "empresaproyecto";

export const AgregarProyectoEmpresa = async (data) => {
    const url = `${controladorProyecto}/AgregarProyectoEmpresa`;
    return await ProcesarDatosApi('POST', url, data);
}

export const ObtenerProyectosEmpresa = async () => {
    const url = `${controladorProyecto}/ObtenerProyectosEmpresa`;
    return await ProcesarDatosApi('GET', url);
}

export const ObtenerEtapasProyecto = async () => {
    const url = `${controladorProyecto}/ObtenerEtapasProyecto`;
    return await ProcesarDatosApi('GET', url);
}

export const EditarProyectoEmpresa = async (data) => {
    const url = `${controladorProyecto}/EditarProyectoEmpresa`;
    return await ProcesarDatosApi('PUT', url, data);
}

export const EliminarProyectoEmpresa = async (idProyecto) => {
    const url = `${controladorProyecto}/EliminarProyectoEmpresa/${idProyecto}`;
    return await ProcesarDatosApi('DELETE', url);
}